import { useQuery } from '@tanstack/react-query';
import { apiService } from '@/lib/api';
import { useEventStore } from '@/store/eventStore';

export function useCompanyEvent() {
  const { setCurrentEvent, setLoading, setError } = useEventStore();
  
  return useQuery({
    queryKey: ['company-event'],
    queryFn: async () => {
      setLoading(true);
      try {
        const event = await apiService.getCompanyEvents();
        setCurrentEvent(event);
        setError(null);
        return event;
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Failed to fetch event';
        setError(errorMessage);
        throw error;
      } finally {
        setLoading(false);
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
  });
}